<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dodaj usługi do zamówienia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="selectedOrderId">

            <div v-if="selectedArticles.length > 0" class="table-responsive"
                 style="border-bottom:1px solid #ddd; padding-bottom:20px">
              <h5>Lista wybranych usług</h5>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Nr Katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Termin dostawy</th>
                  <th>Ilość wymagana</th>
                  <th>J.m.</th>
                  <th>Cena netto PLN</th>
                  <th>Uwagi</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="article in selectedArticles">
                  <td>
                    <button @click="removeFromSelectedArticles(article.id)" class="btn btn-outline-danger btn-xs">
                      Usuń
                    </button>
                  </td>
                  <td>{{ article.id }}</td>
                  <td>{{ article.catalog_number }}</td>
                  <td>{{ article.model }}</td>
                  <td>{{ article.description }}</td>
                  <td class="cell-editable">
                    <input type="date" v-model="article.delivery_date_deadline"
                           class="form-control"/>
                  </td>
                  <td class="cell-editable">
					<input type="number" :min="isIntegerUnit(article.article_unit?.name) ? 1 : null"
							:step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
							v-model="article.quantity_required"
							@input="onQuantityInput(article)"
							@keydown="blockNonNumeric($event, article.article_unit?.name)"
							class="form-control form-control-sm"
						  />						   
						   
						   
                  </td>
                  <td>{{ article.article_unit.name }}</td>
                  <td>{{ article.price_netto_zl }}</td>
                  <td class="cell-editable">
                    <input type="text" v-model="article.comments" class="form-control"/>
                  </td>
                </tr>
                </tbody>
              </table>

              <button type="button" class="btn btn-primary" @click="saveSelectedPositions" :disabled="isSubmitting">
                Dodaj wybrane pozycje
              </button>
            </div>
            <div v-else>
              <span class="text-warning">Wybierz usługi, które chcesz dodać z listy poniżej</span>
            </div>
            <h5 class="pt-4 pb-2">Lista dostępnych artykułów/usług</h5>

            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Ładowanie...</span>
              </div>
              <div class="mt-2">Ładowanie danych...</div>
            </div>

            <ejs-grid ref="addOrderItemsGridRef" id="addOrderItemsGrid" height="500px"
                      v-if="!isLoading"
                      :dataSource="articlesDataManager"
                      :allowTextWrap='false'
                      :allowExcelExport='false'
                      :allowPaging="true"
                      :allowSorting='true'
                      :allowFiltering='true'
                      :allowReordering='true'
                      :allowResizing='true'
                      :showColumnChooser='true'
                      :allowSelection='true'
                      :enablePersistence='false'
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :filterSettings="filterOptions"
                      :toolbar="toolbar"
                      :selectionSettings="selectionOptions"
                      :toolbarClick="clickToolbarHandler">
              <e-columns>
                <e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center"></e-column>
                <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false"
                          :allowEditing="false"/>
                <e-column field="catalog_number" headerText="Nr katalogowy" width="150" :filter="filterDefault"
                          :allowEditing="false"/>
                <e-column field="model" headerText="Model" width="150" :filter="filterDefault"
                          :allowEditing="false"/>
                <e-column field="article_unit.id" headerText="J.m." width="150" editType="dropdownedit"
                          :dataSource="units" foreignKeyValue='name' foreignKeyField='id'
                          :filter='filterUnits' :allowEditing="false"/>
                <e-column field="description" headerText="Nazwa/Opis" :defaultValue="null" width="200"
                          :filter="filterDefault" :allowEditing="false"/>
				<e-column field="price_netto_zl" headerText="Cena netto PLN" :allowEditing="false" type="number"
						  :filter="filterNumeric" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
                <e-column field="suppliers_short_names" headerText="Dostawcy" editType="string"
                              :allowEditing="false" :dataSource="suppliers"
                              :filter="filterSuppliers"/>
                <e-column field="producer_name" headerText="Producent" editType="string"
                              :allowEditing="false" :dataSource="producers"
                              :filter="filterDefault"/>
              </e-columns>

              <template v-slot:addTemplate="{ data }">
                <template v-if="!isArticleSelected(data.id)">
                  <button @click="addToNewItems(data)"
                          class="btn btn-xs btn-outline-primary">Dodaj
                  </button>
                </template>
                <template v-else><span class="text-success">Wybrano</span></template>
              </template>

              <template v-slot:linkTemplate="{data}">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.link>{{
                    data.link
                  }}</a>
              </template>

              <template v-slot:imageTemplate="{ data }">
                <div v-if="data.photos && data.photos.length > 0">
                  <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                       style="max-height: 100px; max-width: 150px"/>
                </div>
              </template>

            </ejs-grid>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <AddArticleModal
  ref="addArticleModalRef"
  @save-article="createArticleFromModal"
  @added-success="successMsg"
  @added-error="errorMsg"
  :units="units"
  :categories="categories"
  :producers="copyproducers"
    :suppliers="suppliers"

/>

</template>

<script>
import {Modal, Tooltip} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  RowDD,
  VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns";
import {DataManager, WebMethodAdaptor} from "@syncfusion/ej2-data";
import {usePage} from "@inertiajs/vue3";
import AddArticleModal from '@/Pages/Warehouses/Articles/AddArticleModal.vue';
import {ref} from "vue";

let dropInstanceFilterUnits, delivererElem = ref(null), multiSelectObj = ref(null);
export default {
  components: {
   AddArticleModal,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    'ejs-datepicker': DatePickerComponent
  },
  props: {
    selectedOrderId: Number,
    suppliers: Object,
    units: Object,
    producers: Object,
	categories: Object,
	project: [Number, String],
	team: [Number, String]
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, RowDD, VirtualScroll]
  },


  data() {
    return {
      errors: {},
      isSubmitting: false,
      isLoading: false,
      viewMode: 'available',
      selectedArticles: [],
      articlesDataManager: [],
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      filterOptions: {type: "Menu", operator: 'contains'},
	  filterNumeric: {operator: 'equal'},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      selectionOptions: {checkboxOnly: true, persistSelection: true},
      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
	        filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: {text: 'short_name', value: 'short_name'},
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
	  
    }
  },

  async mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  beforeMount() {
    this.getArticles();
  },

  methods: {
    // Sprawdza czy jednostka wymaga liczby całkowitej
  isIntegerUnit(unitName) {
    return unitName && ['szt', 'szt.', 'kpl'].includes(unitName.toLowerCase());
  },

  // Blokuje niecyfrowe znaki dla jednostek całkowitych
blockNonNumeric(event, unitName) {
  const allowedKeys = [
    'Backspace','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Delete','Tab'
  ];

  if (allowedKeys.includes(event.key)) return;

  if (this.isIntegerUnit(unitName)) {
    if (!/^\d$/.test(event.key)) event.preventDefault();
  } else {
    if (!/^[\d.,]$/.test(event.key)) event.preventDefault();
  }
},

async createArticleFromModal(payload) {
  const existing = await this.checkCatalogNumber(payload.catalog_number);
  if (existing.length > 0) {
    await this.articleAlreadyExist(existing);
  }
  this.$inertia.post(route('articles.saveChanges'), {
    added: [payload],
  }, {
    only: ['errors', 'flash', 'newRecords', 'articles', 'producers'],
    preserveState: true,

   onSuccess: async (page) => {

     const flashError = page.props.flash?.error;
     if (flashError) {
        Toast.fire({
          position: 'top-end',
          toast: false,
          icon: 'warning',
          title: 'Błąd zapisu',
          html: flashError,
          showConfirmButton: true
        });

        const grid = this.$refs.addOrderItemsGridRef?.ej2Instances;
       if (grid) {
          grid.refresh();
        }
        return;
      }
	  
	  this.copyproducers =  page.props.producers;
	  //this.$refs.addOrderItemsGridRef.ej2Instances.refresh();
await this.getArticles();

this.$nextTick(() => {
  const grid = this.$refs.addOrderItemsGridRef?.ej2Instances;
  grid.dataSource = this.articlesDataManager;
  grid.refreshColumns();
});
	  this.successMsg('Dane zostały zapisane!');
      this.$makeClean();
      this.$refs.addArticleModalRef.hide();
      this.$refs.addArticleModalRef.resetForm();
    },

    onError: (errors) => {
      console.error('Błąd podczas zapisywania danych:', errors);
      this.errorMsg('Błąd podczas zapisywania danych.');
    }
  });
},
      async checkCatalogNumber(catalogNumber) {
      if (catalogNumber) {
        try {
          const response = await axios.post(route('article.check-catalog-number-if-exists'), {
            catalog_number: catalogNumber
          });
          return response.data;
        } catch (error) {
          console.error('Błąd podczas sprawdzania numeru katalogowego:', error);
          return [];
        }
      }
      return [];
    },
    async switchView(mode) {
      this.viewMode = mode;

      if (mode === 'available') {
        await this.getArticles();
      } else if (mode === 'project') {
        await this.getRequiredProjectItems();
      }
    },

    async getRequiredProjectItems() {

      this.isLoading = true;

      try {
		const response = await axios.post(route('requiredProjectItems.getList', {
		  project: this.project,
		  team: this.team,
		}));

        // 1 Spłaszczenie struktury
        const flattened = response.data.map(item => ({
          ...item,
          ...item.article, // przenosimy pola z article.*
          article_unit: item.article?.article_unit,
        }));

        // 2 Usunięcie duplikatów po article.id
        const uniqueByArticle = [];
        const seen = new Set();

        for (const item of flattened) {
          if (!item.article?.id) continue; // pomiń uszkodzone rekordy

          if (!seen.has(item.article.id)) {
            seen.add(item.article.id);
            uniqueByArticle.push(item);
          }
        }

        // 3 Ustaw dane do grida
        this.articlesDataManager = uniqueByArticle;

        // 4 Odśwież grid (jeśli był już wyrenderowany)
        this.$nextTick(() => {
          if (this.$refs.addOrderItemsGridRef?.ej2Instances) {
            this.$refs.addOrderItemsGridRef.ej2Instances.refresh();
          }
        });


      } catch (error) {
        console.error('Błąd przy pobieraniu zapotrzebowania:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async getArticles() {
      this.articlesDataManager = new DataManager({
        url: route('articles.get', {
          project: this.project,
          team: this.team,
          is_usluga: 1,
          without_deleted: true
        }),
        adaptor: new WebMethodAdaptor(),
        batchUrl: route('requiredProjectItems.saveChanges'),
        updateUrl: route('requiredProjectItems.updateChanges'),
        crossDomain: true,
        headers: [
          {'X-CSRF-TOKEN': usePage().props.csrf_token}
        ],
      });
    },

    getToolbar() {
      return [
       {text: "Dodaj artykuł/usługę", prefixIcon: 'e-add', id: 'articles_add'},
        {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
        {text: "Lista artykułów/usług", prefixIcon: 'e-table-of-content', id: 'articles_list'},
        {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
        {text: "Odśwież", prefixIcon: 'e-refresh', id: "refresh", align: 'right'},
      ]
    },

    getEditSettings() {
      return {
        allowEditing: true,
        allowAdding: false,
        allowDeleting: false,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    removeFromSelectedArticles(articleId) {
      this.selectedArticles = this.selectedArticles.filter(item => item.id !== articleId);
    },

    checkQuantity(article) {
      if (article.quantity_required < 1 || isNaN(article.quantity_required)) {
        article.quantity_required = 1;
      }
    },
  // Walidacja i zaokrąglanie ilości wymaganej
onQuantityInput(article) {
  if (article.quantity_required === null || article.quantity_required === '') return;

  if (this.isIntegerUnit(article.article_unit?.name)) {
    article.quantity_required = Math.max(1, Math.floor(article.quantity_required || 1));
  } else {
    let val = article.quantity_required;
    if (typeof val === 'string') val = val.replace(',', '.');
    const parsed = parseFloat(val);
    article.quantity_required = isNaN(parsed) ? null : parsed;
  }
},
    isArticleSelected(articleId) {
      return this.selectedArticles.some(item => item.id === articleId);
    },

    addToNewItems(rowData) {
      if (!this.selectedArticles.find(item => {
        return item.id === rowData.id
      })) {
        this.selectedArticles.push({
          ...rowData,
        });
      }
    },

    clickToolbarHandler: async function (args) {
      /**
       * Akcja przy kliknięciu resetowania filtrów
       */
      if (args.item.id === 'reset_filters') {
        this.$refs.addOrderItemsGridRef.clearFiltering();
      }
	   if (args.item.id === 'articles_add' || args.item.text === 'Add') {
  args.cancel = true;

  this.$refs.addArticleModalRef.show();
  return;
}
	 
      /**
       * Akcja przy kliknięciu listy artykułów
       */
      if (args.item.id === 'articles_list') {
        window.open(route('articles.index'), '_blank');
      }

      /**
       * Akcja przy kliknięciu odświeżania tabeli
       */
      if (args.item.id === 'refresh') {
        this.$refs.addOrderItemsGridRef.ej2Instances.refresh();
      }
    },

    async saveSelectedPositions() {
      if (!this.selectedArticles.length) {
        this.$emit('added-error', {message: 'Nie wybrano żadnych artykułów ze statusem Usługa.'});
        return;
      }

      this.isSending = true;

      let data = this.selectedArticles.map(article => ({
        orderId: this.selectedOrderId,
        article_id: article.id,
        delivery_date_deadline: article.delivery_date_deadline || null, // Jeśli brak, to null
        quantity_required: article.quantity_required && article.quantity_required > 0 ? article.quantity_required : 1, // Jeśli brak lub <1, ustaw na 1
        comments: article.comments || '' // Jeśli brak, to pusty string
      }))

      await axios.post(route('orderListsItems.saveChanges'), {'added': data})
          .then(response => {
            this.$emit('added-success', response.data.message);
            this.$emit('item-added', true);
          }).catch(error => {
            console.log(error);
            this.$emit('added-error', error.response.data);
          });

      this.isSending = false;
      this.hide();
    },

    show() {
      this.selectedArticles = [];
      this.errors = {};
      this.viewMode = 'available';
      this.isLoading = false;
      this.getArticles();

      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
	     successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },
  }
}
</script>